/**
 * PDF viewer HTML template
 */
import { APP_NAME } from "@/constants";

const PDF_VIEWER_TEMPLATE = `
	<!DOCTYPE html>
	<html lang="en">
		<head>
			<meta charset="UTF-8">
			<meta name="viewport" content="width=device-width, initial-scale=1.0">
			<title>${APP_NAME} - File Viewer</title>
			<link rel="icon" href="FAVICON_BASE_URLfavicon.ico">
			<link rel="icon" type="image/png" sizes="32x32" href="FAVICON_BASE_URLfavicon-32x32.png">
			<link rel="icon" type="image/png" sizes="16x16" href="FAVICON_BASE_URLfavicon-16x16.png">
			<link rel="apple-touch-icon" sizes="180x180" href="FAVICON_BASE_URLapple-touch-icon.png">
			<style>
				body {
					margin: 0;
					padding: 0;
					height: 100vh;
					overflow: hidden;
					font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
				}
				#pdf-container {
					width: 100%;
					height: 100%;
				}
			</style>
		</head>
		<body>
			<div id="pdf-container">
				<embed src="PDF_URL_PLACEHOLDER" type="application/pdf" width="100%" height="100%">
			</div>
		</body>
	</html>
`;

/**
 * Creates a PDF viewer HTML page with the given PDF URL and page number
 * @param {string} pdfUrl - The blob URL of the PDF
 * @param {number} pageNumber - The page number to display
 * @returns {string} - The complete HTML content
 */
export function createPdfViewerHtml(pdfUrl, pageNumber) {
	// Get the base URL for favicon paths
	const baseUrl = window.location.origin + (import.meta.env.BASE_URL || "/");

	// Replace the placeholders with actual values
	return PDF_VIEWER_TEMPLATE.replace(/FAVICON_BASE_URL/g, baseUrl).replace(
		"PDF_URL_PLACEHOLDER",
		`${pdfUrl}#page=${pageNumber}`,
	);
}
